import { getOsEnv } from './common/helpers/path.helper';

export const env = {
  app: {
    name: getOsEnv('REACT_APP_NAME'),
    version: getOsEnv('REACT_APP_VERSION'),
    server: getOsEnv('REACT_APP_SERVER')
  },
  auth: {
    domain: getOsEnv('REACT_APP_AUTH_DOMAIN'),
    clientId: getOsEnv('REACT_APP_AUTH_CLIENT_ID'),
    connection: getOsEnv('REACT_APP_AUTH_CONNECTION')
  },
  sentry: {
    dsn: getOsEnv('REACT_APP_SENTRY_DSN'),
    environment: getOsEnv('REACT_APP_SENTRY_ENVIRONMENT'),
    release: getOsEnv('REACT_APP_SENTRY_RELEASE_VERSION')
  },
  beacon: {
    id: getOsEnv('REACT_APP_BEACON_ID')
  },
  logRocket: {
    link: getOsEnv('REACT_APP_LOGROCKET_LINK')
  },
  lever: {
    authURL: getOsEnv('REACT_APP_LEVER_AUTH_URL'),
    clientId: getOsEnv('REACT_APP_LEVER_CLIENT_ID'),
    baseURL: getOsEnv('REACT_APP_LEVER_BASE_URL'),
    scopes: getOsEnv('REACT_APP_LEVER_SCOPES')
  }
};
